import {Injectable} from '@angular/core';
import {CrudService} from "@shared/api/services/crud.service";
import {PatientRecordWeightIndicator} from "@shared/api/models/query/patient-record-weight-indicator.model";
import {PatientRecordWeightIndicatorUpdate} from "@shared/api/models/command/patient-record-weight-indicator.model";

@Injectable({
    providedIn: 'root'
})
export class PatientRecordWeightIndicatorsService extends CrudService<
    PatientRecordWeightIndicator,
    PatientRecordWeightIndicator,
    PatientRecordWeightIndicatorUpdate,
    PatientRecordWeightIndicatorUpdate
> {

    protected override get domainEntity() {
        return 'patients'
    };

    protected override get subdomainEntity() {
        return 'record-weight-indicators';
    };
}
